<template>
  <section>

    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head">
        <div class="title is-bold">Share this evaluation with others</div>
      </header>

      <section class="modal-card-body">

        <div class="subtitle is-bold">Copy this link to share your evaluation.</div>

        <b-message
          auto-close
          type="is-success"
          has-icon
          :active.sync="isSuccessActive"
          aria-close-label="Close message"
        >
          Link copied to clipboard.
        </b-message>

        <table class="table is-bordered is-fullwidth">
          <tr>
            <td
              style="vertical-align: middle;"
              bgcolor="#e8ecf2"
            >
              <p class="level-left">
                Anyone with this link can &nbsp;
                <b-select
                  v-model="rights"
                  @input="getSharedUrl()"
                >
                  <option value="View Only">View Only</option>
                  <option value="Edit">Edit</option>
                </b-select>
              </p>
            </td>
            <td
              class="has-text-right"
              bgcolor="#e8ecf2"
            >
              <button
                class="button is-info"
                v-clipboard:copy="sharedUrl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >Copy link&nbsp;&nbsp;<i class="fas fa-link"></i></button>
            </td>
          </tr>
          <tr>
            <td colspan="2">{{ sharedUrl }}</td>
          </tr>
        </table>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          @click="$parent.close()"
        >Done</button>
      </footer>

    </div>

  </section>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      sharedUrl: undefined,
      isSuccessActive: false,
      rights: "View Only"
    };
  },

  mounted() {
    this.sharedUrl = this.getSharedUrl();
  },

  methods: {
    onCopy() {
      this.isSuccessActive = true;
    },
    onError() {
      alert("Failed to copy texts");
    },
    emailEvaluation() {
      this.$store.state.isShareEvaluationActive = false;
      this.$buefy.toast.open({
        message: `MFQA 1 evaluation shared settings successfull`,
        type: "is-success",
        duration: 5000
      });
    },

    getSharedUrl() {
      console.log("getSharedUrl()");
      let evalType = "";
      if (this.$store.state.evaluation.id.includes("BPOs_")) evalType = "bpos";
      if (this.$store.state.evaluation.id.includes("BPO2s_"))
        evalType = "bpo2s";
      let url = `https://app.lifestylesquest.com/sharing/${evalType}/${
        this.$store.state.evaluation.propertyId
      }/${this.$store.state.evaluation.id}/${
        this.$store.state.evaluation.guid
      }`;
      if (this.rights == "Edit")
        url = url + `/${this.$store.getters.session.sessionKey}`;
      this.sharedUrl = url;
      return url;
    }
  }
};
</script>

<style>
</style>
